import Badge from "../components/ui/Badge";
import BaseAlert from "../components/Modal/BaseAlert";
import BaseButton from "../components/ui/Button/BaseButton";
import BaseCheckbox from "../components/Form/Input/BaseCheckbox";
import BaseInput from "../components/Form/Input/BaseInput";
import BaseInputDate from "../components/Form/Input/BaseInputDate";
import BaseSelect from "../components/Form/Select/BaseSelect";
import BaseSelectMultiple from "../components/Form/Select/BaseSelectMultiple";
import BaseDropdown from "../components/ui/BaseDropdown";
import BaseNav from "../components/Navbar/BaseNav";
import BasePagination from "../components/ui/BasePagination";
import BaseProgress from "../components/ui/BaseProgress";
import BaseRadio from "../components/Form/Input/BaseRadio";
import BaseSlider from "../components/ui/BaseSlider";
import BaseSwitch from "../components/ui/BaseSwitch";
import BaseTable from "../components/ui/BaseTable";
import BaseHeader from "../components/Navbar/BaseHeader";
import InputFile from "../components/Form/Input/InputFile";
import Card from "../components/ui/Card/Card";
import StatsCard from "../components/ui/Card/StatsCard";
import Modal from "../components/Modal/Modal";
import TabPane from "../components/Tabs/TabPane";
import Tabs from "../components/Tabs/Tabs";
import ExcluirModal from "../components/Modal/ExcluirModal";

export default {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseInputDate.name, BaseInputDate);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseSelect.name, BaseSelect);
    Vue.component(BaseSelectMultiple.name, BaseSelectMultiple);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSlider.name, BaseSlider);
    Vue.component('input-file', InputFile);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(BaseTable.name, BaseTable);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(Card.name, Card);
    Vue.component(StatsCard.name, StatsCard);
    Vue.component(Modal.name, Modal);
    Vue.component(TabPane.name, TabPane);
    Vue.component(Tabs.name, Tabs);
    Vue.component('excluir-modal', ExcluirModal);
  }
};
